var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuetify-wrapper v-application" },
    [
      _c(
        "v-card",
        { staticClass: "v-application" },
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v("\n            Terminanfragen pro Datum\n        "),
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pb-0 px-0 v-application--is-ltr" },
            [
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "auto" } },
                        [
                          _c(
                            "v-chip-group",
                            {
                              attrs: {
                                "active-class": "indigo--text text--accent-4",
                                mandatory: "",
                              },
                              on: { change: _vm.changeChip },
                            },
                            [
                              _c("v-chip", [_vm._v("Heute")]),
                              _vm._v(" "),
                              _c("v-chip", [_vm._v("Letzten Woche")]),
                              _vm._v(" "),
                              _c("v-chip", [_vm._v("letzten Monat")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "auto" } },
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                "nudge-right": 40,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "auto",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attr }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "pt-0",
                                              attrs: {
                                                required: "",
                                                readonly: "",
                                                "hide-details": "",
                                                "prepend-icon": "mdi-calendar",
                                                label: "Datumsbereich",
                                              },
                                              model: {
                                                value: _vm.dateRangeText,
                                                callback: function ($$v) {
                                                  _vm.dateRangeText = $$v
                                                },
                                                expression: "dateRangeText",
                                              },
                                            },
                                            "v-text-field",
                                            _vm.attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.isDateMenuOpen,
                                callback: function ($$v) {
                                  _vm.isDateMenuOpen = $$v
                                },
                                expression: "isDateMenuOpen",
                              },
                            },
                            [
                              _vm._v(" "),
                              _c("v-date-picker", {
                                attrs: {
                                  range: "",
                                  "no-title": "",
                                  locale: "de-DE",
                                  "first-day-of-week": 1,
                                },
                                model: {
                                  value: _vm.dateRange,
                                  callback: function ($$v) {
                                    _vm.dateRange = $$v
                                  },
                                  expression: "dateRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "v-row",
                            { staticClass: "py-0" },
                            [
                              _vm.activeTab !== 1
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.appointmentStateOptions,
                                          clearable: "",
                                          label: "Zustand",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.filters.wf_state,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "wf_state",
                                              $$v
                                            )
                                          },
                                          expression: "filters.wf_state",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.activeTab !== 1
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          className: "committed-filter",
                                          items: _vm.committedStateOptions,
                                          clearable: "",
                                          dense: "",
                                          label: "zugesagte / nicht-zugesagte",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.filters.commited,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "commited",
                                              $$v
                                            )
                                          },
                                          expression: "filters.commited",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "6" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.serviceTypeOptions,
                                      clearable: "",
                                      label: "Apotheker / PTA / PKA",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.filters.service,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "service", $$v)
                                      },
                                      expression: "filters.service",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "6" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.isNightShiftOptions,
                                      clearable: "",
                                      label: "Nachtdienst / keine Nachtdienst",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.filters.nightshift,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "nightshift", $$v)
                                      },
                                      expression: "filters.nightshift",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "6" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.hasRequestOptions,
                                      clearable: "",
                                      label:
                                        "Von FB angefragt / Von FB Nicht angefragt ",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.filters.has_request,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "has_request",
                                          $$v
                                        )
                                      },
                                      expression: "filters.has_request",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.requestedAppointments
            ? _c(
                "v-card-text",
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: { color: _vm.tabsConfig[_vm.activeTab].color },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    _vm._l(_vm.tabsConfig, function (tab, idx) {
                      return _c(
                        "v-tab",
                        { key: tab.key },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(tab.label) +
                              "\n                    "
                          ),
                          _c(
                            "v-chip",
                            {
                              staticClass: "chip-small ml-2",
                              attrs: {
                                color: _vm.activeTab == idx && tab.chipColor,
                                outlined: "",
                                small: "",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.tabCount(
                                      _vm.requestedAppointments[tab.key]
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    _vm._l(_vm.tabsConfig, function (tab, idx) {
                      return _c(
                        "v-tab-item",
                        { key: tab.key, attrs: { value: idx } },
                        [
                          _c(
                            "v-card",
                            { attrs: { disabled: _vm.isLoading, flat: "" } },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "pb-0" },
                                [
                                  _c("AppointmentsRequestsPerDateTable", {
                                    attrs: {
                                      requestsData:
                                        _vm.requestedAppointments[tab.key],
                                      isPharmacyRequest: tab.isPharmacyRequest,
                                      isCanceledRequest: tab.isCanceledRequest,
                                      isLoading: _vm.isLoading,
                                    },
                                    on: {
                                      "fetch-requests":
                                        _vm.fetchRequestedAppointments,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _c(
                "v-card-text",
                { staticClass: "text-center" },
                [
                  _c("v-skeleton-loader", {
                    attrs: {
                      "max-width": "700",
                      "max-height": "200",
                      type: "table-thead, table-row@2",
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }